import { toast } from 'react-toastify';
import { AttributeType } from '../../../data/types/attributes';
import { actionSetListingData } from '../store/create_listing_actions';
import { ListingState } from '../../../data/types/listings';
import { Dispatch } from 'react';

export async function linkTempIds(
  state: ListingState,
  dispatch: Dispatch<any>,
  shouldDispatch = true, // Set this to true when all other data has already been dispatched and there is no risk of a race-condition between dispatchs. (i.e for first load it should be false)
) {
  const attributesWithTempId = state?.data?.attributes || [];
  const numericAttrsWithTempId = state.data?.numeric_attrs?.map(
    (item, index: number) => {
      attributesWithTempId.map((attr: any) => {
        if (attr?.attr_id === item.id || attr?.id === item.id) {
          attr.temp_attribute_id = AttributeType.NUMERIC * 1000 + index;
        }
      });
      return {
        ...item,
        temp_attribute_id: AttributeType.NUMERIC * 1000 + index,
      };
    },
  );
  const selectAttrsWithTempId = state.data?.select_attrs?.map(
    (item, index: number) => {
      attributesWithTempId.map((attr: any) => {
        if (attr?.attr_id === item.id || attr?.id === item.id) {
          attr.temp_attribute_id = AttributeType.SELECT * 1000 + index;
        }
      });
      return {
        ...item,
        values_en: state.all_attributes.find((x) => x.id === item.id)
          ?.values_en,
        values_ar: state.all_attributes.find((x) => x.id === item.id)
          ?.values_ar,
        temp_attribute_id: AttributeType.SELECT * 1000 + index,
      };
    },
  );
  const booleanAttrsWithTempId = state.data?.boolean_attrs?.map(
    (item, index: number) => {
      attributesWithTempId.map((attr: any) => {
        if (attr?.attr_id === item.id || attr?.id === item.id) {
          attr.temp_attribute_id = AttributeType.BOOLEAN * 1000 + index;
        }
      });
      return {
        ...item,
        temp_attribute_id: AttributeType.BOOLEAN * 1000 + index,
      };
    },
  );
  console.log('attributesWithTempId', attributesWithTempId);
  console.log('numericAttrsWithTempId', numericAttrsWithTempId);
  console.log('selectAttrsWithTempId', selectAttrsWithTempId);
  console.log('booleanAttrsWithTempId', booleanAttrsWithTempId);
  if (shouldDispatch) {
    dispatch(
      actionSetListingData({
        ...state.data,
        attributes: attributesWithTempId,
        numeric_attrs: numericAttrsWithTempId,
        select_attrs: selectAttrsWithTempId,
        boolean_attrs: booleanAttrsWithTempId,
      }),
    );
    return await toast.promise(
      // wait 3 seconds
      new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            attributesWithTempId,
            numericAttrsWithTempId,
            selectAttrsWithTempId,
            booleanAttrsWithTempId,
          });
        }, 3000);
      }),
      {
        pending: 'Linking temp ids',
        success: 'Linked temp ids',
        error: 'Failed to link temp ids',
      },
    );
  } else {
    return {
      attributesWithTempId,
      numericAttrsWithTempId,
      selectAttrsWithTempId,
      booleanAttrsWithTempId,
    };
  }
}
